import {
	createRouter,
	createWebHistory
} from "vue-router";
import Home from "../views/Home.vue";

const routes = [{
	path: '/',
	redirect: '/dashboard'
}, {
	path: "/",
	name: "Home",
	component: Home,
	children: [{
		path: "/dashboard",
		name: "dashboard",
		meta: {
			title: '充值'
		},
		component: () => import(
			/* webpackChunkName: "dashboard" */
			"../views/Dashboard.vue")
	}]
}, {
	path: "/orderList",
	name: "orderList",
	meta: {
		title: '充值列表'
	},
	component: () => import(
		/* webpackChunkName: "dashboard" */
		"../views/orderList.vue")
}, {
	path: "/login",
	name: "Login",
	meta: {
		title: '登录',
		loginRequest: true
	},
	component: () => import(
		/* webpackChunkName: "login" */
		"../views/Login.vue")
}];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});



export default router;
